module.exports = __webpack_public_path__ + "static/media/JD.23f3c696.svg";